import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getEventRegistrationUrl } from '../utils/creativesReferral';

const ReferralRedirect = ({ children }) => {
  const [searchParams] = useSearchParams();
  const refId = searchParams.get('ref');

  useEffect(() => {
    if (refId && refId !== 'anonymous') {
      const baseUrl = getEventRegistrationUrl('28'); // Using current event
      if (baseUrl) {
        try {
          const url = new URL(baseUrl);
          // Convert underscore back to space for backend parsing
          const cleanRef = refId.replace(/_/g, ' ');
          url.searchParams.set('utm_source', cleanRef);
          window.location.replace(url.toString());
        } catch (err) {
          console.error(err);
        }
      }
    }
  }, [refId]);

  // If a ref is present, show a loading screen instead of rendering the underlying page
  if (refId && refId !== 'anonymous') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', fontSize: '18px', color: '#555' }}>
        Redirecting to registration...
      </div>
    );
  }

  // Otherwise, render the page normally
  return children;
};

export default ReferralRedirect;
